<template>
  <transition
      enter-active-class="animate__animated animate__fadeInDown animate__delay_1s"
      leave-active-class="animate__animated animate__fadeOutDown animate__delay_1s">
    <div v-if="isShow" class="message-box position-fixed" style="z-index: 10">
      <div class="prompt-success d-flex align-content-center shadow-lg" >
        <b-icon :icon="icon" font-scale="2" :style="`background: ${bgColor};color: white`"></b-icon>
        <div class="text-black-50 font-weight-bold prompt-success-text d-flex align-items-center justify-content-center">
          {{!!msg?msg:'successfully'}}
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Success",
  data(){
    return {
      isShow:false,
      type:'',
      msg:'successfully'
    }
  },
  computed:{
    icon(){
      let val = '';
      switch (this.type){
        case 'success':val = 'check';break;
        case 'error':val = 'x';break;
      }
      return val;
    },
    bgColor(){
      let val = '';
      switch (this.type){
        case 'success':val = 'rgb(19,206,102)';break;
        case 'error':val = 'rgb(255,73,73)';break;
      }
      return val;
    }
  },
  methods:{
    show(){
      this.isShow = true
      setTimeout(() => { this.isShow = false},1500)
    },
    success(msg){
      this.type = 'success';
      this.msg = msg;
      this.show();
    },
    error(msg){
      this.type = 'error';
      this.msg = msg;
      this.show();
    }
  }
}
</script>

<style lang="scss">
//.fade-prompt-enter-active, .fade-prompt-leave-active {
//  transition: all 0.5s;
//}
//.fade-prompt-enter, .fade-prompt-leave-to /* .fade-leave-active below version 2.1.8 */ {
//  transform: translateY(-100%);
//  opacity: 0;
//}
.message-box{
  background: white;
  top: 18%;
  left: 43%;
}
.prompt-success{
  border-radius: 5px;
  width: 300px;
  .prompt-success-text{
    width: 100%;
  }
}
</style>